module.exports = __webpack_public_path__ + "media/du.306be1f3.wav";